import {useQuery} from "@apollo/client";
import {Navigate} from "react-router";

import {DashboardDefinitionResult, GQL_GET_DEFAULT_DASHBOARD} from "@/lib/queries/website.ts";

export const DashboardRoot = () => {
  const {data} = useQuery<DashboardDefinitionResult>(GQL_GET_DEFAULT_DASHBOARD);

  if (!data) return null;

  return <Navigate to={`/dashboard/${data.dashboardDef.id}`} />;
};
